"use client";

import React from "react";
import { Construction, Wrench, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
interface UnderConstructionProps {
  title?: string;
  description?: string;
  showHomeButton?: boolean;
}
export function UnderConstruction({
  title = "Page en cours de construction",
  description = "Nous travaillons activement sur cette section pour vous offrir la meilleure expérience possible. Revenez très bientôt !",
  showHomeButton = true
}: UnderConstructionProps) {
  return <div className="min-h-[60vh] w-full flex flex-col items-center justify-center text-center px-4 py-16 bg-[#1a1d24] text-white rounded-2xl border border-white/10 shadow-2xl">
      {/* Icone animée */}
      <div className="relative mb-6 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full bg-[#ffcc00]/20 blur-xl animate-pulse" />
        <div className="relative p-5 rounded-full bg-[#ffcc00]/10 border border-[#ffcc00]/30 text-[#ffcc00]">
          <Construction className="size-12 md:size-16 animate-bounce" />
        </div>
        <Wrench className="absolute -bottom-1 -right-1 size-6 text-[#ffcc00] rotate-45" />
      </div>

      {/* Titre */}
      <h2 className="text-2xl md:text-4xl font-extrabold uppercase tracking-tight mb-4 text-[#f1f3f5]">
        {title}
      </h2>

      {/* Barre décorative */}
      <div className="h-1 w-20 bg-[#ffcc00] mb-6 rounded-full" />

      {/* Description */}
      <p className="max-w-md text-sm md:text-base text-[#a0aec0] leading-relaxed mb-8">
        {description}
      </p>

      {/* Bouton de retour */}
      {showHomeButton && <Button asChild className="bg-[#ffcc00] hover:bg-[#e6b800] text-[#121417] font-black uppercase py-5 px-6 rounded-xl transition-all duration-200 shadow-md">
          <Link to="/">
            <ArrowLeft className="size-4 mr-2" />
            Retour à l'accueil
          </Link>
        </Button>}
    </div>;
}